module.exports = __webpack_public_path__ + "img/emoji_94.7aacdb3c.png";